import React, { useEffect, useRef } from 'react'
import companyData from "./tableData.json";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  fetchVehicleMake,
  initializeVehicleMakeScreen,
  setDeleteConfirmationPopupVisibility,
  exportVehicleMake,
  saveVehicleMakeTableState,
} from "../../../redux/actions/vehicles/vehicleMake";
import VehicleMake from '../../../component/Vehicles/VehicleMake';
import { generatePath } from 'react-router-dom';
import { loadingShow } from '../../../services/PostAPI';
import { APP_URLS } from '../../../utils/constant';
import { FILTER } from "../../../services/common/urlService";
import { DATE_STRATEGY, formatDate } from "../../../utils/date";
function VehicleMakeScreen(props) {
  const {
    fetchVehicleMake,
    initVehicleMakeScreen,
    showPageLevelLoader,
    vehicleMakeListview,
    screenPermissions,
    paginationInfo,
    exportVehicleMake,
    isVehicleMakeExportError,
    isVehicleMakeExportSuccess,
    isLoading,
    savedTableState,
    saveVehicleMakeTableState,
  } = props;
  const navigate = useNavigate();

  // Use ref to capture initial savedTableState to avoid closure issues
  const initialSavedState = useRef(savedTableState);

  const buildFetchParamsFromSavedState = (state) => {
    if (!state) return null;
    
    // Helper to check if a string looks like an ISO date
    const isISODateString = (str) => {
      if (typeof str !== 'string') return false;
      return /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}/.test(str);
    };
    
    // Helper to format date values to YYYY-MM-DD
    const formatFilterValue = (value) => {
      if (value instanceof Date) {
        return formatDate(value, DATE_STRATEGY.DATE_ISO);
      }
      if (isISODateString(value)) {
        return formatDate(new Date(value), DATE_STRATEGY.DATE_ISO);
      }
      return value;
    };
    
    // Build filter params in the format expected by the API
    const filters = [];
    if (state.filters) {
      Object.keys(state.filters).forEach(key => {
        if (key !== 'global' && state.filters[key]?.value !== null && state.filters[key]?.value !== undefined) {
          const filterValue = state.filters[key].value;
          filters.push({
            filterField: state.filters[key].filterKey || key,
            matchStrategy: state.filters[key].matchStrategy || FILTER.MATCH_STRATEGY.CONTAINS,
            query: formatFilterValue(filterValue)
          });
        }
      });
    }
    
    return {
      sortField: state.sortField || 'id',
      sortOrder: state.sortOrder,
      pageNumber: state.page || 0,
      pageSize: state.rows || 10,
      filters: filters.length > 0 ? filters : undefined
    };
  };

  useEffect(() => {
    initVehicleMakeScreen();
    
    // Fetch with saved state params if available, otherwise use defaults
    const savedParams = buildFetchParamsFromSavedState(initialSavedState.current);
    
    if (savedParams) {
      fetchVehicleMake(savedParams);
    } else {
      fetchVehicleMake({ sortField: 'id' });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const loadLazyData = (props) => {
    fetchVehicleMake(props);
  };

  const handleTableStateChange = (tableState) => {
    saveVehicleMakeTableState(tableState);
  };

  const handleCreateVehicleMake = () => {
    navigate(APP_URLS.VEHICLE_MAKE.CREATE);
  }
  const editVehicleMakeRoute = (id) => {
    const path = generatePath(APP_URLS.VEHICLE_MAKE.EDIT, {
      id,
    });
    navigate(path);
  };
  const vehicleMake = {
    handleCreateVehicleMake,
    exportVehicleMake,
    isVehicleMakeExportError,
    isVehicleMakeExportSuccess,
    editVehicleMakeRoute,
    screenPermissions,
    setDeleteConfirmationPopupVisibility,
    fetchVehicleMakes: loadLazyData,
    tableData: {
      columns: vehicleMakeListview?.columns,
      rows: vehicleMakeListview?.rows,
    },
    paginationInfo: {
      pageSize: paginationInfo?.pageSize,
      pageNumber: paginationInfo?.pageNumber,
      totalPages: paginationInfo?.totalPages,
      totalRecords: paginationInfo?.totalRecords,
    },
    isLoading,
    savedTableState,
    onTableStateChange: handleTableStateChange,
  };

  if (showPageLevelLoader) {
    loadingShow("block");
    return null;
  }
  loadingShow("none");
  return (
    <div>
      <VehicleMake
        {...vehicleMake}
      />
    </div>
  )
}


const mapDispatchToProps = (dispatch) => {
  return {
    initVehicleMakeScreen: () => dispatch(initializeVehicleMakeScreen()),
    fetchVehicleMake: (payload) => dispatch(fetchVehicleMake(payload)),
    setDeleteConfirmationPopupVisibility: (payload) =>
      dispatch(setDeleteConfirmationPopupVisibility(payload)),
    exportVehicleMake: (payload) => dispatch(exportVehicleMake(payload)),
    saveVehicleMakeTableState: (payload) => dispatch(saveVehicleMakeTableState(payload)),
  };
};


//vehicleCagegoryReducer
const mapStateToProps = (state, ownProps) => {
  return {

    isVehicleMakeCreateSuccess: selectFromVehicleMakeReducer(
      state,
      "isVehicleMakeCreateSuccess"
    ),
    vehicleMakeListview: selectFromVehicleMakeReducer(
      state,
      "vehicleMakeListview"
    ),
    showPageLevelLoader: selectFromVehicleMakeReducer(
      state,
      "showPageLevelLoader"
    ),
    paginationInfo: selectFromVehicleMakeReducer(
      state,
      "paginationInfo"
    ),
    isPageLevelError: selectFromVehicleMakeReducer(
      state,
      "isPageLevelError"
    ),
    isFetchingGridData: selectFromVehicleMakeReducer(
      state,
      "isFetchingGridData"
    ),
    isVehicleMakeExportError: selectFromVehicleMakeReducer(
      state,
      "isVehicleMakeExportError"
    ),
    isVehicleMakeExportSuccess: selectFromVehicleMakeReducer(
      state,
      "isVehicleMakeExportSuccess"
    ),
    savedTableState: selectFromVehicleMakeReducer(
      state,
      "savedTableState"
    ),
    ...ownProps,
  };
};

const selectFromVehicleMakeReducer = (state, path) => {
  return selectVehicleMakeReducer(state)[path];
};

const selectVehicleMakeReducer = ({ vehicleMakeReducer }) => {
  return vehicleMakeReducer;
};


export default connect(mapStateToProps, mapDispatchToProps)(VehicleMakeScreen);
